export default __webpack_public_path__ + "static/media/calendar.d0be0ec1.svg";